export function getVideoUrl(profileId: string): string {
  return `/videos/${profileId}.mp4`
}

export function getVideoPosterUrl(profileId: string): string {
  return `/videos/${profileId}-poster.jpg`
}
